import { env } from './env';

type Stages = 'local' | 'dev' | 'beta' | 'production';

class Config {
  public get rootElementId(): string {
    return 'root';
  }

  // Environment stage of the Web App
  public get stage(): Stages {
    return env.STAGE as Stages;
  }

  public get basename(): string {
    return env.BASENAME;
  }

  /** Url of the API */
  public get apiUrl(): string {
    return env.API_URL;
  }

  /** Clerk publishable key for authentication */
  public get clerkPublishableKey(): string {
    return env.CLERK_PUBLISHABLE_KEY;
  }

  /** API Key for Locize */
  public get locizeApiKey(): string {
    return env.LOCIZE_API_KEY;
  }

  /** Project Id for the Locize Project */
  public get locizeProjectId(): string {
    return env.LOCIZE_PROJECT_ID;
  }

  public get muiLicenseKey(): string {
    return env.MUI_LICENSE_KEY;
  }
}

export const config = new Config();
